import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ custom, palette }: Theme) => ({
  modalContent: {
    paddingTop: 48,
    width: '100%',
    minHeight: 'min(466px, 50vh)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: {
    marginBottom: 20,
    padding: 8,
    fontSize: 70,
    position: 'relative',
    display: 'block',
    margin: `0 auto -35px`,
    borderRadius: '100%',
    color: palette.common.white,
  },
  successIcon: {
    backgroundColor: custom.green[1],
  },
  warningIcon: {
    padding: 15,
    backgroundColor: palette.primary.main,
  },
  heading: {
    fontSize: 22,
    color: custom.grey[3],
    fontFamily: 'Merriweather',
    fontWeight: 900,
    width: '100%',
    textAlign: 'center',
    '& > h4': {
      margin: 0,
      padding: '0 0 15px 0',
    },
    '& > h2': {
      margin: 0,
      padding: '0 0 15px 0',
      '& > span': {
        whiteSpace: 'pre',
        color: custom.green[1],
      },
    },
  },
  description: {
    maxWidth: 333,
    margin: 0,
    fontSize: 14,
    lineHeight: 1.43,
    color: custom.grey[2],
    textAlign: 'center',
  },
  submitButton: {
    marginTop: 20,
    marginBottom: 6,
    minHeight: 50,
    fontSize: 16,
    fontWeight: 900,
  },
}));
